import { render, staticRenderFns } from "./webcam.vue?vue&type=template&id=4406b0bd"
import script from "./webcam.vue?vue&type=script&lang=js"
export * from "./webcam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4406b0bd')) {
      api.createRecord('4406b0bd', component.options)
    } else {
      api.reload('4406b0bd', component.options)
    }
    module.hot.accept("./webcam.vue?vue&type=template&id=4406b0bd", function () {
      api.rerender('4406b0bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/avatar/webcam.vue"
export default component.exports